import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({ error, errorInfo });
    this.logErrorToBackend(error, errorInfo);
  }

  logErrorToBackend = async (error, errorInfo) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.warn('Cannot log error - user not authenticated');
        return;
      }
      
      const response = await fetch('http://localhost:5000/api/client-error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          error: error.toString(),
          errorInfo: errorInfo.componentStack,
          stackTrace: error.stack,
          location: window.location.pathname,
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          url: window.location.href,
          severity: 'high',
          additionalData: {
            componentStack: errorInfo.componentStack,
            errorName: error.name,
            errorMessage: error.message
          }
        })
      });

      if (response.ok) {
        console.log('✅ Error logged to backend successfully');
      } else {
        console.error('❌ Failed to log error to backend:', response.status);
      }
    } catch (err) {
      console.error('Failed to send error to backend:', err);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          backgroundColor: '#fff3f3',
          border: '2px solid #ff4444',
          borderRadius: '8px',
          margin: '20px'
        }}>
          <h2 style={{ color: '#d32f2f' }}>⚠️ Something went wrong</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            We've logged this error and will fix it soon.
          </p>
          <details style={{ 
            textAlign: 'left', 
            backgroundColor: '#f5f5f5', 
            padding: '15px',
            borderRadius: '4px',
            marginBottom: '20px'
          }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '10px' }}>
              Error Details (for developers)
            </summary>
            <pre style={{ 
              fontSize: '12px', 
              overflow: 'auto',
              color: '#d32f2f'
            }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </details>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;